export const initialState = {
  languages: [],
  filters: {},
  activeLanguage: 'en'
};
